import platform from 'components/Trackers/platform'
import { useTracking } from 'utils/analytics/useTracking'

export const useOccupationTracking = () => {
  const track = useTracking(screenViewed)

  return {
    nextTapped: () => track.buttonTapped(nextTapped),
  }
}

const sharedProps = {
  platform,
  card_type: 'moc',
  context: 'registration',
  screen: 'registrationSpendOccupation',
  screen_name: 'registrationSpendOccupation',
}

const screenViewed = {
  object: 'Screen',
  action: 'Viewed',
  object_name: 'registrationSpendOccupation',
  ...sharedProps,
}

const nextTapped = {
  object: 'Button',
  action: 'Tapped',
  object_name: 'registrationSpendOccupationNext',
  ...sharedProps,
}
